<template>
  <div v-if="taxonomyItems.length">
    <label
      :for="taxonomy"
      class="heading-font text-sm uppercase font-normal mg-color-secondary-lighter"
      >{{ label }}</label
    >
    <div class="relative">
      <select
        v-model="selected"
        @change="selectChange"
        class="mg-form-control mg-select w-full rounded-lg text-base"
        :id="taxonomy"
      >
        <option value="">select</option>
        <option
          :value="item.id"
          v-for="(item, index) in taxonomyItems"
          :key="index"
          ><span v-html="item.name"></span
        ></option>
      </select>
      <div
        class="pointer-events-none absolute pin-y pin-r flex items-center px-2 mg-color-accent-2"
      >
        <svg class="fill-current h-8 w-8">
          <use href="#icon-angle-down" xlink:href="#icon-angle-down" />
        </svg>
      </div>
    </div>
  </div>
  <div
    v-else
    class="mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-sm"
  >
    loading options...
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from "vuex";
  import eventHub from "../event-hub";

  import getQueryParam from "../utilities/get-query-param";

  export default {
    props: ["taxonomy", "label", "feedType"],
    name: "taxonomy-select",
    data() {
      return {
        parentName: this.$parent.$options.name,
        selected: "",
      };
    },
    computed: {
      ...mapState({
        taxonomyItems(state) {
          if (this.taxonomy == "commodity") {
            return state.tax_commodities;
          } else if (this.taxonomy == "state") {
            return state.state;
          } else if (this.taxonomy == "region") {
            return state.regions;
          } else if (this.taxonomy == "topic") {
            return state.topics;
          } else if (this.taxonomy == "country") {
            return state.tax_countries;
          } else if (this.taxonomy == "categories") {
            return state.categories;
          } else if (this.taxonomy == "member_type") {
            return state.member_type;
          } else if (this.taxonomy == "member_area_of_business") {
            return state.member_area_of_business;
          } else if (this.taxonomy == "year") {
            return this.getYearsArray();
          } else if (this.taxonomy == "alphabet") {
            return this.getAlphabetArray();
          }
        },
      }),
    },
    methods: {
      ...mapMutations(["updateUrlHashFilter"]),
      ...mapActions([
        "getTaxonomy",
        "getNewsroomFeed",
        "getReportsFeed",
        "handleFilters",
      ]),
      selectChange() {
        const payload = {
          type: this.parentName,
          taxonomy: this.taxonomy,
          selected: this.selected,
        };

        this.handleFilters({ ...payload });

        let h = {};
        h[this.taxonomy] = this.selected;
        this.updateUrlHashFilter(h);

        if (this.parentName != "member-filter") {
          // Call the appropriate feed based on feedType prop
          if (this.feedType === "reports") {
            this.getReportsFeed();
          } else {
            this.getNewsroomFeed();
          }
        }
      },
      getYearsArray() {
        // 2010 has the oldest content
        const startYear = 2010;

        let yearCount = new Date().getFullYear(),
          years = [];

        while (yearCount >= startYear) {
          const obj = {
            id: yearCount,
            name: yearCount,
          };
          years.push(obj);
          yearCount--;
        }

        return years;
      },
      getAlphabetArray() {
        let alphabet = [];

        "abcdefghijklmnopqrstuvwxyz".split("").forEach((letter) => {
          const obj = {
            id: letter,
            name: letter.toUpperCase(),
          };

          alphabet.push(obj);
        });

        return alphabet;
      },
      resetSelected() {
        this.selected = "";
      },
      checkPredefinedFilter() {
        let urlFilter = location.hash.substring(1);

        if (!urlFilter) return;

        urlFilter = `?${urlFilter}`;
        const filterValue = parseInt(getQueryParam(this.taxonomy, urlFilter));

        if (filterValue) {
          const payload = {
            type: this.parentName,
            taxonomy: this.taxonomy,
            selected: filterValue,
          };

          this.handleFilters({ ...payload });

          this.selected = filterValue;
        }
      },
    },
    created() {
      this.checkPredefinedFilter();

      if (this.taxonomy != "year") {
        // Pass feedType to getTaxonomy so it knows which endpoint to use
        this.getTaxonomy({ taxonomy: this.taxonomy, feedType: this.feedType });
      }

      eventHub.$on("form-reset", this.resetSelected);
    },
    // It's good to clean up event listeners before
    // a component is destroyed.
    beforeDestroy: function() {
      eventHub.$off("form-reset", this.resetSelected);
    },
  };
</script>



// WEBPACK FOOTER //
// src/js/vue-components/taxonomy-select.vue